import { axiosV4 } from "../../../Utils/Axios/axiosV4";

export const getTicketingSlidersService = async (userToken: string) => {
  return axiosV4.get("/user/ticketing-sliders", {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
